import { environment } from '@env/environment';
import {BehaviorSubject, Observable} from 'rxjs';
import * as io from 'socket.io-client';
import feathers, {Service} from '@feathersjs/feathers';
import feathersSocketIoClient from '@feathersjs/socketio-client';
import feathersAuthentication from '@feathersjs/authentication-client';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class ApiService {
  private app: any;
  readonly socket: any;

  // Subjects
  private $connected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  // Observables
  public connected$: Observable<boolean> = this.$connected.asObservable();

  constructor() {
    this.socket = io(environment.backendUrl);
    this.socket.on('connect', () => {
      this.$connected.next(true);
    });
    this.socket.on('disconnect', (reason) => {
      this.$connected.next(false);
    });
    this.app = feathers()
      .configure(feathersSocketIoClient(this.socket, {timeout: 60000}))
      .configure(feathersAuthentication({
        storage: window.localStorage
      }));
  }

  public service(item: string): Service<any> {
    return this.app.service(item);
  }

  public authenticate(credentials?): Promise<any> {
    return this.app.authenticate(credentials);
  }

  public reAuthenticate(): Promise<any> {
    return this.app.reAuthenticate();
  }

  public async logout(): Promise<void> {
    await this.app.authentication.logout();
    this.app.logout();
  }
}
